<template>
    <div class="container">
        <div class="content">
            <div class="search-wrap">
                <div class="search-l">
                    <el-form>
                        <el-form-item label="活动状态">
                            <el-select v-model="activityStatus" placeholder="请选择活动状态">
                                <el-option label="全部" value="0"></el-option>
                                <el-option label="未开始" value="1"></el-option>
                                <el-option label="进行中" value="2"></el-option>
                                <el-option label="已结束" value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="search-r">
                    <el-input placeholder="请输入搜索内容" v-model="keyWords" @change="toSearch">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
            </div>
            <ul class="nav-list">
                <li :class="[activeIndex==-1?'active':'']" @click="toAll">全部</li>
                <li :class="[activeIndex==index?'active':'']" @click="toChangeNav(item.id, index)" v-for="(item,index) in navList" :key="index">{{item.categoryName}}</li>
            </ul>
            <ul class="list" v-if="dataList.length >0">
                <li v-for="(item,index) in dataList" @click="toDetail(item.id)" :key="index">
                    <div class="list-img">
                        <img :src="item.picUrl" />
                    </div>
                    <div class="list-title">
                        <h3>{{item.name}}</h3>
                    </div>
                    <div class="list-tips">
                        <div class="article-tags-wrap" v-if="item.talkName">
                            <div class="article-tags">
                                <span class="tags-icon">#</span>
                                <span class="tags-name">{{item.talkName}}</span>
                            </div>
                        </div>
                        <a v-if="item.holdStatus==1" href="javascript:;">进行中</a>
                        <a v-else-if="item.holdStatus==2" class="end-btn" href="javascript:;">已结束</a>
                        <a v-else href="javascript:;" class="begin-btn">未开始</a>
                        <div class="sign" v-if="item.holdStatus!=2 && item.enrollFlag == 0" @click.stop="toSign(item)">报名</div>
                        <div class="sign" v-if="item.holdStatus!=2 && item.enrollFlag == 1" @click.stop="toSign(item)">取消报名</div>
                    </div>
                    <div class="list-txt">
                        <div class="list-txt-l">
                            <span>浏览 {{item.viewNum || 0}}</span>
                        </div>
                        <div class="list-txt-r">
                            时间：{{item.beginTime | datefmt('yyyy-MM-DD')}}～{{item.endTime | datefmt('yyyy-MM-DD')}}
                        </div>
                    </div>
                    <div class="list-txtd">
                        <div class="list-txt-l">
                            <span>参与人数 {{item.enrollNum || 0}}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <Empty v-else content="该分类下无数据" />
            <div v-if="total>pageSize">
                <Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange" />
            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
import Pagination from '@/components/pagination'
import Empty from '@/components/empty'
export default {
    name: 'activity',
    components: {
        Pagination,
        Empty
    },
    data() {
        return {
            navList: [],
            pageSize: 9,
            pageNum: 1,
            categoryId: '', //分类id
            userId: '',
            dataList: [],
            total: 0,
            holdStatus: '', //0未开始 1进行中 2已结束
            activityStatus: '0',
            keyWords: '',
            activeIndex: -1
        }
    },
    watch: {
        activityStatus(newValue, oldValue) {
            this.holdStatus = newValue - 1
            this.dataList = []
            this.pageNum = 1
            this.getDataList()
        }
    },
    created() {
        this.userId = localStorage.getItem('userId')
        this.getNavList()
        this.toAll();
    },
    methods: {
        //获取大赛分类数据
        async getNavList() {
            let param = {}
            ajaxParam(param)
            const res = await post('v1/activity/getActivityCategory', qs.stringify(param))
            if (res.data.code == 200) {
                console.log(res.data)
                this.navList = res.data.list
                if (this.navList.length > 0) {
                    //this.categoryId = this.navList[0].id
                    this.getDataList()
                }
            } else {
                this.$message.error(res.data.msg)
            }
        },
        //获取大赛数据列表
        async getDataList() {
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                categoryId: this.categoryId,
                holdStatus: this.holdStatus,
                searchKeyWord: this.keyWords
            }
            ajaxParam(param)
            const res = await post('v1/activity/getActivityList', qs.stringify(param))
            if (res.data.code == 200) {
                this.dataList = res.data.list
                this.total = res.data.total
            } else {
                this.$message.error(res.data.msg)
            }
        },
        pageChange(e) {
            this.dataList = []
            this.pageNum = e.number
            this.getDataList()
        },
        toSearch(e) {
            console.log(e)
            this.keyWords = e
            this.dataList = []
            this.pageNum = 1
            this.getDataList()
        },
        toChangeNav(id, index) {
            this.activeIndex = index
            this.categoryId = id
            this.dataList = []
            this.pageNum = 1
            this.getDataList()
        },
        toAll() {
            this.activeIndex = -1
            this.categoryId = ''
            this.dataList = []
            this.pageNum = 1
            this.getDataList()
        },
        toDetail(id) {
            this.$router.push({
                path: '/activityDetail?id=' + id
            })
        },
        toSign(item){
            this.$confirm(`确定要${item.enrollFlag == 0 ? '报名' : '取消报名'}吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.submintSing(item)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
            });
        },
        async submintSing(item){
            let param = {
                userId: this.userId,
                activityId: item.id
            }
            ajaxParam(param)
            const res = await post('v1/activity/enrollActivity', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success('提交成功！')
                this.getDataList()
            } else {
                this.$message.error(res.data.msg)
            }
        }
    }
}
</script>
<style scoped lang="less">
.content {
    width: 1180px;
    margin: 20px auto;
    padding: 0 40px 40px;
    background: #fff;
    border-radius: 12px;
    box-sizing: border-box;
    overflow: hidden;

    .search-wrap {
        display: flex;
        justify-content: space-between;
        padding: 10px 0 16px;
        border-bottom: 1px solid var(--color-border);

        .search-l {
            flex: 1;

            /deep/ .el-form-item {
                margin-bottom: 0;
            }

            /deep/ .el-select>.el-input {
                width: 145px;
            }

            /deep/ .el-select-dropdown__item.selected {
                color: var(--color-text-a);
            }
        }

        .search-r {
            padding-top: 8px;
        }

        /deep/ .el-input__inner {
            height: 30px;
            line-height: 30px;
        }

        /deep/ .el-input-group__append {
            padding: 0 10px
        }

        /deep/ .el-input__inner:focus {
            border-color: #DCDFE6
        }
    }

    .nav-list {
        display: flex;
        flex-wrap: wrap;

        li {
            height: 32px;
            margin-top: 16px;
            margin-right: 20px;
            padding: 0 20px;
            background: #F3F4F7;
            border-radius: 16px;
            line-height: 32px;
            text-align: center;
            font-weight: 500;
            cursor: pointer;
        }

        li.active {
            background: var(--color-text-a);
            color: #fff;
        }
    }

    .list {
        display: flex;
        flex-wrap: wrap;

        li {
            display: flex;
            flex-direction: column;
            width: 32.3333%;
            margin-right: 1.3333%;
            margin-top: 16px;
            background: #fff;
            border: 1px solid rgba(50, 50, 50, .1);
            border-radius: 4px;
            box-sizing: border-box;
            cursor: pointer;
            overflow: hidden;

            .list-img {
                img {
                    width: 100%;
                    height: 240px;
                    max-width: 380px;
                    max-height: 214px;
                }
            }

            .list-title {
                margin-top: 12px;
                margin-bottom: 4px;
                padding: 0 17px;
                line-height: 24px;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: .86px;
                -webkit-line-clamp: 1;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }

            .list-tips {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 5px 17px 0;

                .article-tags-wrap {
                    display: flex;
                    cursor: pointer;
                }

                .article-tags {
                    display: flex;
                    border: 1px solid var(--color-border);
                    margin-right: 15px;
                    padding: 3px 5px;
                    border-radius: 14px;

                    .tags-icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 4px;
                        background: #DD0515;
                        border-radius: 14px;
                        color: #fff;
                        line-height: 18px;
                        text-align: center;
                    }

                    .tags-name {
                        font-size: 12px;
                        color: var(--color-text);
                    }
                }

                span {
                    color: var(--color-text-a);
                }

                a,.sign {
                    width: 78px;
                    height: 28px;
                    background: #DD0515;
                    border-radius: 4px;
                    text-align: center;
                    line-height: 28px;
                    color: #fff;
                }

                .end-btn {
                    background: #F3F4F7;
                    color: var(--color-text-opacity);
                }

                .begin-btn {
                    background: rgba(207, 23, 29, 0.1);
                    border: 1px solid #DD0515;
                    color: var(--color-text-a);
                }
            }

            .list-txt {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                padding: 0 17px;
                font-size: 12px;
                color: var(--color-text-opacity);
                line-height: 22px;
            }
            .list-txtd {
                padding: 0 17px;
                font-size: 12px;
                margin-bottom: 10px;
                color: var(--color-text-opacity);
                line-height: 22px;
            }
        }

        li:nth-of-type(3n) {
            margin-right: 0;
        }

        li:hover {
            position: relative;
            box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
            border-radius: 6px;
            z-index: 1
        }
    }
}
</style>